import { GetCommentsInDto, GetCommentsOutDto } from '../../../types/comment.dto';

export const GET_COMMENTS = 'GET_COMMENTS';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR';
export const RESET_COMMENTS = 'RESET_COMMENTS';

export interface GetComments {
  type: typeof GET_COMMENTS;
  payload: GetCommentsOutDto;
}

export interface GetCommentsSuccess {
  type: typeof GET_COMMENTS_SUCCESS;
  payload: GetCommentsInDto;
  append: boolean;
}

export interface GetCommentsError {
  type: typeof GET_COMMENTS_ERROR;
  payload: string | boolean;
}

export interface ResetComments {
  type: typeof RESET_COMMENTS;
  payload: null;
}

export interface State {
  data: GetCommentsInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetComments | GetCommentsSuccess | GetCommentsError | ResetComments;
